module.exports = __webpack_public_path__ + "static/img/qianju.7dd0a9ab.png";